import { storeToRefs } from "pinia";
import type { RouteRecordNormalized } from "vue-router";

import { isIframe } from "@/common/is-iframe";
import { useAuthStore } from "@/stores";

export default (to: RouteRecordNormalized) => {
  if (isIframe()) {
    const { isAuthenticated } = storeToRefs(useAuthStore());

    if (!to.meta.isIframeRoute && !isAuthenticated.value) {
      return { name: "iframe.login" };
    }

    return;
  }

  if (to.meta.isIframeRoute === true) {
    return { name: "home" };
  }
};
